export default "__VITE_PUBLIC_ASSET__20103f6a__"